import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import { Separator } from "@/components/ui/separator"
import { AppName } from "@/constants/application/application"
import { ButtonVariant } from "@/constants/button/button"
import { CredentialMethod } from "@/constants/credentials/credential"
import { getRespectiveForm } from "@/pages/Credentials/helpers/getRespectiveForm"
import { App } from "@/types/applications"
import { LoginMethod } from "@/types/credentials"

export const CreateAndUseNewCredential = ({
  isOpen,
  onClose,
  credentialSource,
  loginMethods
}: {
  isOpen: boolean,
  onClose: () => void,
  credentialSource: App,
  loginMethods: LoginMethod[]
}) => {

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogTitle className="mb-6">
          <div className="flex flex-row items-center justify-between">
            <AlertDialogFooter className="absolute right-6 top-6">
              <AlertDialogCancel asChild>
                <Button className="rounded rounded-full h-8 w-8" variant={ButtonVariant.DEFAULT}>
                  X
                </Button>
              </AlertDialogCancel>
            </AlertDialogFooter>
          </div>
        </AlertDialogTitle>
        <Label className="flex justify-start text-2xl leading-4 font-semibold text-primary" >
          Create Credential
        </Label>
        <div className="flex flex-row items-center font-normal text-base leading-5 text-primary mb-3">
          <div className="flex flex items-center justify-center rounded-sm border-2 border-border h-12 w-12 p-2 mr-4 bg-foreground">
            <img src={credentialSource.logo} className="h-5" />
          </div>
          {credentialSource.displayName}
        </div>
        <Separator />
        {getRespectiveForm(
          credentialSource.name as AppName,
          credentialSource.id,
          loginMethods,
          CredentialMethod.CREATE,
          true,
        )}
      </AlertDialogContent>
    </AlertDialog >
  )
}
